
import { useState, useRef, useContext } from "react";
import { Row, Col, Button , Form, InputGroup, ListGroupItem} from "react-bootstrap"
import { Card, ListGroup } from "react-bootstrap"
import Icon from "../Icon/Icon";
import ListGroupTextItem from "./Elements/ListGroupTextItem";

import { useApiClient } from "../../ApiService/useApiClient";
import { AppContext } from "../../context/AppContext";


const PersonalDetails = ({datainfo}) => {

  const {SiteConfig} = useContext(AppContext);
  const api = useApiClient();

  const [data, setData] = useState(datainfo.agent); 
  
  const[restrictedMode, setRestrictedMode] = useState((SiteConfig.CURRENT_USER_ROLE=="user"?true:false));

  
  const fullname = (data.title??'') +' '+ data.agentFname +' '+ data.agentLname;

  const [editMode, setEditMode] = useState(false);
  const [error,setError] = useState(null);
  const modalForm = useRef(null);

  //console.log(data)

function HandleEditClick(){
  setEditMode(true)
}
function HandlePreviewClick(){
  setEditMode(false)
}

function handleFormSubmit(event){

  event.preventDefault();
  let Title = modalForm.current.querySelector('#Title').value; 
  let AgentFname = modalForm.current.querySelector('#AgentFname').value; 
  let AgentLname = modalForm.current.querySelector('#AgentLname').value; 
  let Phone = modalForm.current.querySelector('#Phone').value; 
  let eMail = modalForm.current.querySelector('#eMail').value; 
  let Mobile = modalForm.current.querySelector('#Mobile').value; 
  let Address = modalForm.current.querySelector('#Address').value; 
  let Gender = modalForm.current.querySelector('#Gender').value; 
  let DateofBirth = modalForm.current.querySelector('#DateofBirth').value; 
  let NiNumber = modalForm.current.querySelector('#NiNumber').value; 
  let transportPayMethod = modalForm.current.querySelector('#transportPayMethod').value; 
  let transportPay = modalForm.current.querySelector('#transportPay').value; 
 //let Password = modalForm.current.querySelector('#Password').value; 

  const frmFormData = new FormData();
        frmFormData.append("AgentId", data.agentId) 
        frmFormData.append("Title", Title) 
        frmFormData.append("AgentFname", AgentFname) 
        frmFormData.append("AgentLname", AgentLname)  
        frmFormData.append("TelNo", Phone)  
        frmFormData.append("EmailId", eMail)  
        frmFormData.append("MobileNo", Mobile)  
        frmFormData.append("Address", Address)  
        frmFormData.append("Gender", Gender)  
        frmFormData.append("DateOfBirth", DateofBirth)  
        frmFormData.append("NiNumber", NiNumber)  
        frmFormData.append("TransportPayMethod", transportPayMethod)  
        frmFormData.append("TransportPay", transportPay)  
        //frmFormData.append("Password", Password)  
                      
        //console.log(frmFormData);


        const sURL = "HMCareStaff/staff/modify/";

        
        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;  

            //console.log({updatedDataObj})

            setData(updatedDataObj)          
            //updateState(updatedDataObj)
            
        }).catch(error => {
            setError(error);     
            //console.log({error})
        });


  setEditMode(false)
}

const ShowTransportPayType = (sTransPayCode)=>{

  if(sTransPayCode == "") return "No Payment";
  if(sTransPayCode == "per_mile") return "Fixed amount per mile";
  if(sTransPayCode == "per_day") return "Fixed amount per day";
  if(sTransPayCode == "per_month") return "Fixed amount per month";

}

 
 
  return (

<><Form ref={modalForm} onSubmit={handleFormSubmit}>
<Row>
{!editMode && !restrictedMode && <div className="col-md-12" style={{textAlign:"left", marginBottom:"5px",}}><span onClick={HandleEditClick} style={{cursor:"pointer", color:"green", textAlign:"right", }}><Icon name="edit"></Icon> Edit</span></div>}
{/* {editMode && !restrictedMode && <div className="col-md-12" style={{textAlign:"left",}}><span onClick={HandlePreviewClick} style={{cursor:"pointer", color:"green", textAlign:"right",}}><Icon name="save-fill"></Icon> Save</span></div> } */}
 
{editMode && 
  <>
      <div className="col-md" style={{padding:"15px",}}>     
        <Button variant="primary" size="md" type="submit">Save Changes</Button>         
        <Button variant="danger" size="md" onClick={HandlePreviewClick} style={{marginLeft:"10px",}}><Icon name="cancel-fill"></Icon> Cancel</Button>     
      </div>          
      </>    
      }   
</Row>
 {/* <br></br> */}
<Row>

  <div className="col-md-6">  
  <Card>    
      <ListGroup variant="flush" style={{ padding: "15px" }}>
      <ListGroupTextItem editMode={editMode} id={"ID"} name={"ID"} value={data.agentId} />
          
            {!editMode && <ListGroupTextItem editMode={editMode} id={"Name"} name={"Name"} value={fullname} />}
            {editMode && 
            <ListGroup.Item>
             <InputGroup size="sm">
             <InputGroup.Text>Name</InputGroup.Text>
             <Form.Control id="Title" type="text" defaultValue={data.title??''} placeholder="Title" />
             <Form.Control id="AgentFname" type="text" defaultValue={data.agentFname} placeholder="First Name(s)" />
             <Form.Control id="AgentLname" type="text" defaultValue={data.agentLname} placeholder="Last Name(s)" />
           </InputGroup>
           </ListGroup.Item>    
            }
                                    
          <ListGroupTextItem editMode={editMode} id={"Phone"} name={"Phone"} value={data.telNo}  />
          <ListGroupTextItem editMode={editMode} id={"Mobile"} name={"Mobile"} value={data.mobileNo}  />
          <ListGroupTextItem editMode={editMode} id={"eMail"} name={"eMail"} value={data.emailId}  />
          <ListGroupTextItem editMode={editMode} id={"Address"} name={"Address"} value={data.address}  />
          
                   
          {/* <ListGroup.Item><LableValueDisplay name={"Mobile"} value={data.mobileNo} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"eMail"} value={data.emailId} /></ListGroup.Item>
          <ListGroup.Item><span className="title fw-medium w-40 d-inline-block">Address :</span><br></br>{data.address}</ListGroup.Item>           */}
      </ListGroup>
  </Card>
  </div>
  <div className="col-md-6 mx-auto" style={{ paddingBottom: "12px" }}>
  <Card>
      {/* <Card.Header>Service Details</Card.Header> */}
      <ListGroup variant="flush" style={{ padding: "15px" }}>

      {!editMode && <ListGroupTextItem editMode={editMode} id={"Gender"} name={"Gender"} value={data.gender}  />}
      {editMode && 
        <ListGroup.Item>
          <InputGroup size="sm">
            <InputGroup.Text>Gender</InputGroup.Text>
            <Form.Select id="Gender" name="Gender" defaultValue={data.gender} >
                <option value="male">Male</option>
                <option value="female">Female</option>                
            </Form.Select>
          </InputGroup>          
        </ListGroup.Item>
        }
   


      <ListGroupTextItem editMode={editMode} id={"DateofBirth"} name={"Date of Birth"} value={data.dateOfBirth} imputtype="date" />
      <ListGroupTextItem editMode={editMode} id={"NiNumber"} name={"NI Number"} value={data.niNumber}  /> 

          {/* <ListGroup.Item><LableValueDisplay name={"Gender"} value={data.gender} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Date of Birth"} value={data.dateOfBirth} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"NHS Number"} value={data.hnsNumber} /></ListGroup.Item>                  */}
      </ListGroup>
      <ListGroup variant="flush" style={{ padding: "15px" }}>

      {!editMode && <ListGroupTextItem editMode={editMode} id={"transportPayMethod"} name={"Transport Pay Method"} value={ShowTransportPayType(data.transportPayMethod)}  />}
      {editMode &&   
      <ListGroup.Item>
          <InputGroup size="sm">
            <InputGroup.Text>Transport Pay Method</InputGroup.Text>
            <Form.Select id="transportPayMethod" name="Transport Pay Method" defaultValue={data.transportPayMethod??""} >
                <option value="">No Payment</option>
                <option value="per_mile">Per Mile</option>
                <option value="per_day">Fixed Amount Per Day</option>                
                <option value="per_month">Fixed Amount Per Month</option>                
            </Form.Select>
          </InputGroup>          
        </ListGroup.Item>}
        <ListGroupTextItem editMode={editMode} id={"transportPay"} name={"Transport Pay (£)"} value={data.transportPay}  />
      </ListGroup>
      
  </Card>  
   
  </div> 
  
</Row></Form>
<br></br>
   </>  

  )

}

export default PersonalDetails